// utils/gtagIframe.js
let iframeInstance = null;
let hasInitialized = false;

export const initGtagIframe = (trackingId) => {
    // Prevent duplicate initialization
    if (hasInitialized) {
        return iframeInstance;
    }

    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.id = 'gtag-video-tracking-iframe';
    iframe.srcdoc = `
        <!DOCTYPE html>
        <html>
        <head>
            <script async src="https://www.googletagmanager.com/gtag/js?id=${trackingId}"></script>
            <script>
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                
                // Initialize WITHOUT automatic page view
                gtag('config', '${trackingId}', {
                    send_page_view: false
                });
                
                // Listen for manual page view commands
                window.addEventListener('message', function(e) {
                    if (e.data && e.data.type === 'gtag_page_view') {
                        // Send page_view with full page_location URL
                        var params = e.data.params || {};
                        var fullUrl = window.parent.location.protocol + '//' + 
                                     window.parent.location.host + 
                                     params.page_path;
                        
                        // Send to dataLayer directly (bypasses validation)
                        window.dataLayer.push({
                            'event': 'page_view',
                            'page_location': fullUrl,
                            'page_path': params.page_path,
                            'page_title': params.page_title,
                            'send_to': '${trackingId}'
                        });
                    }
                });
            </script>
        </head>
        </html>
    `;
    
    document.body.appendChild(iframe);
    iframeInstance = iframe;
    hasInitialized = true;
    
    return iframe;
};

export const sendGtagPageView = (iframe, params = {}) => {
    if (!iframe || !iframe.contentWindow) {
        console.warn('Gtag iframe not ready');
        return;
    }
    
    iframe.contentWindow.postMessage({
        type: 'gtag_page_view',
        params: params
    }, '*');
};

export const destroyGtagIframe = () => {
    if (iframeInstance && iframeInstance.parentNode) {
        iframeInstance.parentNode.removeChild(iframeInstance);
        iframeInstance = null;
        hasInitialized = false;
    }
};